export default "__VITE_ASSET__My3qtiE2__"